import React, { useState } from "react";
import { RevendaComponentProps } from "screens/revenda/utils";
import * as S from "./style";
import { ReservadoVendidoComponent } from "./reservadoVendido.component";
import { UnidadeGeralComponent } from "./unidadeGeral.component";

enum R {
  RV = 1,
  UG = 2,
}

export const RelatoriosRevendaComponent: React.FC<RevendaComponentProps> = ({
  authToken,
}) => {
  const [tab, setTab] = useState(R.RV);

  return (
    <S.Container>
      <S.Tabs
        value={tab}
        variant="fullWidth"
        scrollButtons="auto"
        aria-label="tabs"
      >
        <S.Tab
          disableRipple
          value={R.RV}
          label={"Reservado x Vendido"}
          onClick={() => {
            if (tab !== R.RV) setTab(R.RV);
          }}
          selected={tab === R.RV}
        />
        <S.Tab
          disableRipple
          value={R.UG}
          label={"Unidade x Geral"}
          onClick={() => {
            if (tab !== R.UG) setTab(R.UG);
          }}
          selected={tab === R.UG}
        />
      </S.Tabs>

      {tab === R.RV && (
        <ReservadoVendidoComponent authToken={authToken} shouldClear={!!tab} />
      )}
      {tab === R.UG && (
        <UnidadeGeralComponent authToken={authToken} shouldClear={!!tab} />
      )}
      {!tab && <>Erro</>}
    </S.Container>
  );
};
